<template>
  <div class="apply-confirm">
    <div class="header">
      <van-nav-bar
        title="发票预览"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <div :class="['sell',marginTop ? 'sell-top' : '']">
      <p class="sell-name">销方名称</p>
      <div class="change-sell-company">
        {{this.$store.state.user.company.name || '--'}}
      </div>
    </div>
    <div :class="['return-reason']" v-if="detailData.applyReturnFlag === 1">
      <p class="sell-name">退回原因</p>
      <div class="change-sell-company">
        {{detailData.applyReturnReason}}
      </div>
    </div>
    <div class="buy">
      <p class="buy-title">购方名称</p>
      <div class="buy-name">
        {{detailData.purchaserName || newDetailData.purchaserName || '--'}}
        <span v-if="detailData.personLogo === 1 || newDetailData.personLogo === 1">(个人)</span>
      </div>
      <div class="label">
        <div class="left">购方税号</div>
        <div class="right">{{detailData.purchaserTaxNo || newDetailData.purchaserTaxNo || '--'}}</div>
      </div>
      <template v-if="isAllElectric(detailData.invoiceType || newDetailData.invoiceType)">
        <div class="label">
          <div class="left">地址</div>
          <div class="right">{{detailData.purchaserAddress || newDetailData.purchaserAddress || '--'}}</div>
        </div>
        <div class="label">
          <div class="left">电话</div>
          <div class="right">{{detailData.purchaserTel || newDetailData.purchaserTel || '--'}}</div>
        </div>
        <div class="label">
          <div class="left">开户行</div>
          <div class="right">{{detailData.purchaserBankName || newDetailData.purchaserBankName || '--'}}</div>
        </div>
        <div class="label">
          <div class="left">账号</div>
          <div class="right">{{detailData.purchaserBankAccount || newDetailData.purchaserBankAccount || '--'}}</div>
        </div>
      </template>
      <template v-else>
        <div class="label">
          <div class="left">地址,电话</div>
          <div class="right">{{detailData.purchaserAddress || newDetailData.purchaserAddress || '--'}}</div>
        </div>
        <div class="label">
          <div class="left">开户行及账号</div>
          <div class="right">{{detailData.purchaserBankName || newDetailData.purchaserBankName || '--'}}</div>
        </div>
      </template>
    </div>
    <div class="ticket" v-if="!comeFormDian">
      <div class="label">
        <div class="left">开票日期</div>
        <div class="right" v-if="this.$route.query.look">
          {{detailData.updateTime || newDetailData.updateTime}}
        </div>
        <div class="right" v-else>{{getTime}}</div>
      </div>
      <div class="label">
        <div class="left">价税合计</div>
        <div class="right" v-if="this.$route.query.look">{{autoNumber(Number(detailData.amountWithTax || newDetailData.amountWithTax))}}</div>
        <div class="right" v-else>{{autoNumber(Number(this.$route.query.sum))}}</div>
      </div>
      <div class="label">
        <div class="left">金额</div>
        <div class="right" v-if="this.$route.query.look">{{autoNumber(Number(detailData.amount || newDetailData.amount))}}</div>
        <div class="right" v-else>{{autoNumber(Number(money))}}</div>
      </div>
      <div class="label">
        <div class="left">税额</div>
        <div class="right" v-if="this.$route.query.look">{{autoNumber(Number(handleOncount(Number(detailData.amountWithTax || newDetailData.amountWithTax),Number(detailData.amount || newDetailData.amount),'sub')))}}</div>
        <div class="right" v-else>{{autoNumber(Number(handleOncount(Number(this.$route.query.sum), Number(money), 'sub')))}}</div>
      </div>
      <div class="label">
        <div class="left">发票备注</div>
        <div class="right">{{detailData.remark || newDetailData.remark}}</div>
      </div>
      <div class="label" v-if="detailData && detailData.settlementSource === 7">
        <div class="left">订单编号</div>
        <div class="right">{{detailData.externalDocumentNo || newDetailData.externalDocumentNo}}</div>
      </div>
      <div class="label" v-if="detailData && detailData.settlementSource === 7">
        <div class="left">单据附注</div>
        <div class="right">{{detailData.notes || newDetailData.notes}}</div>
      </div>
    </div>
    <div class="ticket" v-if="comeFormDian">
      <!-- <div class="label">
        <div class="left">开票日期</div>
        <div class="right">{{getTime}}</div>
      </div> -->
      <div class="label">
        <div class="left">价税合计</div>
        <div class="right">{{autoNumber(Number(messageJiner))}}</div>
      </div>
      <div class="label">
        <div class="left">金额</div>
        <!-- <div class="right">{{Number(messageJiner)-Number(messageShuier)}}</div> -->
        <div class="right">{{autoNumber(Number(handleOncount(Number(messageJiner), Number(messageShuier), 'sub')))}}</div>
      </div>
      <div class="label">
        <div class="left">税额</div>
        <div class="right">{{autoNumber(Number(messageShuier))}}</div>
      </div>
      <div class="label">
        <div class="left">发票备注</div>
        <div class="right">{{detailData.remark || newDetailData.remark || '--'}}</div>
      </div>
      <div class="label" v-if="detailData && detailData.settlementSource === 7">
        <div class="left">订单编号</div>
        <div class="right">{{detailData.externalDocumentNo || newDetailData.externalDocumentNo || '--'}}</div>
      </div>
      <div class="label" v-if="detailData && detailData.settlementSource === 7">
        <div class="left">单据附注</div>
        <div class="right">{{detailData.notes || newDetailData.notes || '--'}}</div>
      </div>
    </div>
    <div>
    </div>
    <div v-if="detailData && detailData.settlementSource !== 7" :class="['dept']">
      <p class="dept-name">所在部门</p>
      <div class="change-dept-company">
        {{detailData.deptName || newDetailData.deptName}}
      </div>
    </div>
    <div class="ticket specific-business">
      <SpecificBusiness
        :readonly="true"
        :data="detailData.specificElementVOs || newDetailData.specificElementVOs || []"
        ref="specific-business"
        v-if="
          (detailData.elementCode && detailData.elementCode !== '01')
          ||
          (newDetailData.elementCode && newDetailData.elementCode !== '01')
        "
        :elementCode="detailData.elementCode || newDetailData.elementCode"
      />
    </div>
    <!-- <DetailForm :detailList="detailList" :detailData="formatDetailData" /> -->
    <!-- <div class="title">
      商品管理
    </div> -->
     <div class="shop-detail" v-if="!comeFormDian">
        <div class="shop-detail-title">
          <!-- sellerInvoiceDetails -->
          <div v-if="this.$route.query.look">商品明细 <span>({{detailData && detailData.sellerInvoiceDetails ? detailData.sellerInvoiceDetails.length : newDetailData && newDetailData.sellerInvoiceDetails ? newDetailData.sellerInvoiceDetails.length : '0'}})</span></div>
          <div v-else>商品明细 <span>({{moreGoods ? moreGoods.length : '0'}})</span></div>
          <div>向左滑动查看更多</div>
        </div>
        <div class="more" v-if="this.$route.query.look">
          <div class="more-title">
            <div class="more-left">
              <div class="more-left-title">项目名称</div>
              <div class="more-names" v-for="(item,index) in (detailData.sellerInvoiceDetails || newDetailData.sellerInvoiceDetails)" :key="index">
                {{ item.shortName ? '*' + (item.shortName.split('*').join('')) + '*' + item.goodsName : item.goodsName }}
              </div>
            </div>
            <div class="more-right">
              <div class="scroll-wrp">
                <section>
                  <div>规格型号</div>
                  <div>单位</div>
                  <div>单价</div>
                  <div>数量</div>
                  <div>金额(不含税)</div>
                  <div>税率</div>
                  <div>税额</div>
                  <div>金额(含税)</div>
                </section>
                <div class="moer-content list-bottom" v-for="(item,index) in (detailData.sellerInvoiceDetails || newDetailData.sellerInvoiceDetails)" :key="index">
                  <div>{{ item.specification }}</div>
                  <div>{{ item.unit }}</div>
                  <div>{{autoNumber(Number(item.unitPrice))}}</div>
                  <div>{{ item.quantity }}</div>

                  <div>{{autoNumber(Number(item.amount))}}</div>
                  <div>{{autoNumber(Number(item.taxRate))}}</div>
                  <div>{{autoNumber(Number(item.amountWithTax) - Number(Number(Number(item.amount))))}}</div>
                  <div>{{autoNumber(Number(item.amountWithTax))}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="more" v-else>
          <div class="more-title">
            <div class="more-left">
              <div class="more-left-title">项目名称</div>
              <div class="more-names" v-for="(item,index) in moreGoods" :key="index">
                {{ item.shortName ? '*' + (item.shortName.split('*').join('')) + '*' + item.goodsName : item.goodsName }}
              </div>
            </div>
            <div class="more-right">
              <div class="scroll-wrp">
                <section>
                  <div>规格型号</div>
                  <div>单位</div>
                  <div>单价</div>
                  <div>数量</div>
                  <div>金额(不含税)</div>
                  <div>税率</div>
                  <div>税额</div>
                  <div>金额(含税)</div>
                </section>
                <div class="moer-content list-bottom" v-for="(item,index) in moreGoods" :key="index">
                  <div>{{ item.specification }}</div>
                  <div>{{ item.unit }}</div>
                  <div>{{autoNumber(Number(item.unitPrice))}}</div>
                  <div>{{ item.quantity }}</div>

                  <div>{{autoNumber(Number(item.amount))}}</div>
                  <div>{{autoNumber(Number(item.taxRate))}}</div>
                  <div>{{autoNumber(Number(item.amountWithTax) - Number(Number(Number(item.amount))))}}</div>
                  <div>{{autoNumber(Number(item.amountWithTax))}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div class="shop-detail" v-if="comeFormDian">
        <div class="shop-detail-title">
          <div>商品明细<span>({{detailData && detailData.details ? detailData.details.length : newDetailData && newDetailData.details ? newDetailData.details.length : '0'}})</span></div>
          <div>向左滑动查看更多</div>
        </div>
        <div class="more">
          <div class="more-title">
            <div class="more-left">
              <div class="more-left-title">项目名称</div>
              <div class="more-names" v-for="(item,index) in (detailData.details || newDetailData.details)" :key="index">
                {{ item.shortName ? '*' + (item.shortName.split('*').join('')) + '*' + item.goodsName : item.goodsName }}
              </div>
            </div>
            <div class="more-right">
              <div class="scroll-wrp">
                <section>
                  <div>规格型号</div>
                  <div>单位</div>
                  <div>单价</div>
                  <div>数量</div>
                  <div>金额(不含税)</div>
                  <div>税率</div>
                  <div>税额</div>
                  <div>金额(含税)</div>
                </section>
                <div class="moer-content list-bottom" v-for="(item,index) in (detailData.details || newDetailData.details)" :key="index">
                  <div>{{ item.specification }}</div>
                  <div>{{ item.unit }}</div>
                  <div>{{autoNumber(Number(item.unitPrice))}}</div>
                  <div>{{ item.quantity }}</div>

                  <div>{{autoNumber(Number(Number(Number(item.amountWithTax) / Number(1 + item.taxRate)).toFixed(2)))}}</div>
                  <div>{{autoNumber(Number(item.taxRate))}}</div>
                  <div>{{autoNumber(Number(item.amountWithTax) - Number(Number(Number(item.amountWithTax) / Number(1 + item.taxRate))))}}</div>
                  <div>{{autoNumber(Number(item.amountWithTax))}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mg-top"></div>
      <div class="other" v-if="detailData && detailData.settlementSource !== 7">
        <p class="other-title">其他内容</p>
        <div class="label">
          <div class="left">说明注释</div>
          <div class="right">{{detailData.notes || newDetailData.notes}}</div>
        </div>
        <div class="extended">
          <!-- 扩展字段 -->
          <ExtendedFields :formData="detailData.purchaserName ? detailData : newDetailData" :ispreview="true" />
        </div>
        <p class="upload">上传附件</p>
        <div class="img">
          <div v-for="(item,index) in (detailData.files || newDetailData.files)" :key="index">
            <img :src="getThumbnail(item.url)" alt="">
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Button,
  NavBar
} from 'vant'
import {
  ConvertNumber,
  renderTextWithConfig,
  deepCopy,
  onCount,
  NumFormat,
  isAllElectric
} from '@utils/basicUtil'
import {
  INVOICE_TYPE,
  INVOICE_METHOD,
  GET_TYPE
} from '@assets/config'
import SpecificBusiness from '@components/SpecificBusiness'
import ExtendedFields from '@/components/ExtendedFields'
// import DetailForm from '../DetailForm/index.vue'
import { THUMBNAIL_CONFIG } from '@/assets/config'
export default {
  props: ['detailData', 'goodsList', 'comeFormDian'],
  data: () => ({
    moreGoods: [],
    newDetailData: {},
    length: 0,
    money: 0,
    sum: 0,
    shui: 0,
    messageJiner: 0,
    messageShuier: 0,
    marginTop: false,
    formCustomerList: [
      {
        field: 'receiverName',
        label: '收件人'
      },
      {
        field: 'receiverAddress',
        label: '收件地址'
      },
      {
        field: 'receiverPhone',
        label: '电话'
      },
      {
        field: 'receiverEmail',
        label: '邮箱'
      }
    ],
    formatDetailData: {}
  }),
  watch: {
    detailData (v) {
      this.getFormatDetailData()
    }
  },
  computed: {
    isAllElectric () {
      return (type) => {
        return !!isAllElectric(type)
      }
    },
    getThumbnail () {
      return (url) => {
        return THUMBNAIL_CONFIG(url)
      }
    },
    detailList () {
      const { proxyFlag, logisticsFlag, invoiceType } = this.$store.state.invoice.formData
      const basicInfo = [
        {
          field: 'proxyFlag',
          label: '开票类型',
          render: (text) => renderTextWithConfig(text, INVOICE_METHOD)
        },
        {
          field: 'invoiceType',
          label: '发票类型',
          render: (text) => renderTextWithConfig(text, INVOICE_TYPE)
        },
        {
          field: 'logisticsFlag',
          label: '取票方式',
          render: (text) => { return text === undefined ? '' : renderTextWithConfig(text ? text.toString() : '-', GET_TYPE) }
        },
        {
          field: 'purchaserName',
          label: '客户名称'
        },
        {
          field: 'purchaserTaxNo',
          label: '客户税号'
        },
        {
          field: 'purchaserAddress',
          label: '地址、电话'
        },
        {
          field: 'purchaserBankName',
          label: '银行、账号'
        },
        {
          field: 'remark',
          label: '发票备注'
        }
      ]
      const takerInfo = [
        {
          field: 'takeDate',
          label: '预约取票日期'
        },
        {
          field: 'taker',
          label: '取票人姓名'
        },
        {
          field: 'takerIdCard',
          label: '身份证号码'
        },
        {
          field: 'takerTelephone',
          label: '手机号码'
        }
      ]
      if (proxyFlag === 1 && logisticsFlag !== '1' && invoiceType !== '3') {
        return [...basicInfo, ...takerInfo]
      } else {
        return basicInfo
      }
    },
    getTime () {
      let d = new Date()
      let m
      if (d.getMonth() + 1 > 9) {
        m = d.getMonth() + 1
      } else {
        m = '0' + (d.getMonth() + 1)
      }
      return `${d.getFullYear()}-${m}-${d.getDate()}`
    },
    autoNumber () {
      return function (num) {
        return NumFormat(num)
      }
    }
  },
  mounted () {
    if (sessionStorage.detailData) {
      this.newDetailData = JSON.parse(sessionStorage.detailData)
    } else {
      this.newDetailData = this.detailData
    }
    if (window.location.pathname === '/invoice/detail') {
      this.marginTop = true
    }
    if (sessionStorage.nowGoodsMessage && !this.comeFormDian) {
      var amount = 0
      var taxAmount = 0
      if (sessionStorage.nowGoodsMessage) {
        this.$store.state.invoice.goodsList = JSON.parse(sessionStorage.nowGoodsMessage)
      }
      this.$store.state.invoice.goodsList.forEach((item) => {
        this.length += Number(item.quantity)
        amount += item.quantity ? Number(item.quantity) * item.price / (1 + Number(item.taxRate)) : item.amount
        taxAmount += Number(item.quantity) * item.price - amount
      })
      this.shui = taxAmount
      this.money = amount
    }
    if (this.comeFormDian) {
      const detail = this.detailData.details || this.newDetailData.details
      detail.forEach((item, index) => {
        this.messageJiner += Number(item.amountWithTax)
        this.messageShuier += Number(item.amountWithTax) - Number(Number(Number(item.amountWithTax) / Number(1 + item.taxRate)).toFixed(2))
      })
    }
    this.getFormatDetailData()
    if (sessionStorage.nowGoodsMessage) {
      this.moreGoods = JSON.parse(sessionStorage.nowGoodsMessage)
    }
  },
  methods: {
    handleOncount (front, rear, symbols) {
      let result = onCount[symbols](front, rear)
      return Number(result).toFixed(2)
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    renderInvoiceType (text) {
      return renderTextWithConfig(text, INVOICE_TYPE)
    },
    renderGetType (text) {
      return renderTextWithConfig(text, GET_TYPE)
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    getFormatDetailData () {
      this.formatDetailData = deepCopy(this.detailData)
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    ExtendedFields,
    SpecificBusiness
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
